<template>
  <div class="login">
    <div class="container">
      <div class="layui-card">
        <div class="layui-card-header">
          <h2>登录</h2>
        </div>
        <div class="layui-card-body">
          <form class="layui-form" @submit.prevent="login">

            <div class="layui-form-item">
              <label class="layui-form-label align-left">用户名</label>
              <div class="layui-input-block padding-right">
                <input v-model="loginInfo.user" type="text" name="title" required  lay-verify="required" placeholder="请输入用户名" autocomplete="off" class="layui-input">
              </div>
            </div>

            <div class="layui-form-item">
              <label class="layui-form-label align-left">密码</label>
              <div class="layui-input-block padding-right">
                <input v-model="loginInfo.password" type="password" name="password" required  lay-verify="required" placeholder="请输入密码" autocomplete="off" class="layui-input">
              </div>
            </div>

            <div class="layui-form-item">
              <button class="layui-btn" lay-submit lay-filter="formDemo">用户登录</button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loginInfo: {
        user: '',
        password: ''
      }
    }
  },
  methods: {
    login () {
      if (this.loginInfo.user === 'admin' && this.loginInfo.password === '4007077999') {
        this.$store.commit('login')
        this.$router.push({ name: 'home' })
      } else {
        alert('输入错误，请重试。')
      }
    }
  }
}
</script>

<style scoped lang="less">
.login {
  background-color: #f2f2f2;
  width: 100vw;
  height: 100vh;
  padding-top: 200px;
  box-sizing: border-box;
  .container {
    width: 450px;
    margin: auto;
    .align-left {
      text-align: left;
    }
    .padding-right {
      padding-right: 15px;
    }
  }
}
</style>
